import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgModelGroup = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 79.541,
	height: 81.462,
	viewBox: "0 0 79.541 81.462",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_16948",
		"data-name": "Group 16948",
		transform: "translate(-1015 -58.538)",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Group_16892",
			"data-name": "Group 16892",
			transform: "translate(1016 59.538)",
			opacity: .199,
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_16889",
					"data-name": "Group 16889",
					transform: "translate(74.309 32.739)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Path_12548",
						"data-name": "Path 12548",
						d: "M3,9.99H6.231",
						transform: "translate(-3 -8.374)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_12549",
						"data-name": "Path 12549",
						d: "M3.5,9.49v3.231",
						transform: "translate(-1.884 -9.49)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_16890",
					"data-name": "Group 16890",
					transform: "translate(58 0)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Path_12546",
						"data-name": "Path 12546",
						d: "M6.5,4V16.113",
						transform: "translate(-0.444 -4)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_12547",
						"data-name": "Path 12547",
						d: "M5.5,5H17.613",
						transform: "translate(-5.5 1.057)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_16891",
					"data-name": "Group 16891",
					transform: "translate(0 61)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Path_12546-2",
						"data-name": "Path 12546",
						d: "M6.5,4v6.462",
						transform: "translate(-3.269 -4)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_12547-2",
						"data-name": "Path 12547",
						d: "M5.5,5h6.462",
						transform: "translate(-5.5 -1.769)",
						fill: "none",
						stroke: "currentColor",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: 2
					})]
				})
			]
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Earth_Pin_Location_Direction",
			"data-name": "Earth, Pin, Location, Direction",
			transform: "translate(1018 70)",
			opacity: .6,
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12592",
					"data-name": "Path 12592",
					d: "M0,0H70V70H0Z",
					transform: "translate(70 70) rotate(180)",
					fill: "none"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12593",
					"data-name": "Path 12593",
					d: "M21.712,27.25s10.214-8.385,10.214-16.042a10.214,10.214,0,0,0-20.428,0c0,7.656,10.214,16.042,10.214,16.042Z",
					transform: "translate(22.038 1.917)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12594",
					"data-name": "Path 12594",
					d: "M15.482,4.35a.729.729,0,1,1-.732.729.725.725,0,0,1,.732-.729",
					transform: "translate(28.271 8.337)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12595",
					"data-name": "Path 12595",
					d: "M27.882,4.025a26.268,26.268,0,1,0,18.935,6.72",
					transform: "translate(5.75 7.715)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12596",
					"data-name": "Path 12596",
					d: "M15.784,44.2V44c0-5.833,11.667-5.145,11.667-11.667,0-5.833-8.75-5.833-8.75-14.583C18.7,9.5,12.867,9,4.117,9H3.939",
					transform: "translate(7.55 17.244)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_12597",
					"data-name": "Path 12597",
					d: "M21.679,30.864a8.606,8.606,0,0,1-1.295-.592,8.784,8.784,0,1,1,8.87-15.164,9.028,9.028,0,0,1,.849.618",
					transform: "translate(30.733 26.653)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 4
				})
			]
		})]
	})
});
export default SvgModelGroup;
